import React from "react";
import { ReactComponent as Avatar } from "./../../assets/icons/Avatar.svg";
import Searchbar from "./searchbar";

const Header = () => {
  return (
    <div className="p-0 h-9 bg-white flex justify-center ruby shadow z-50">
      <div className="m-2 flex flex-col sm:flex-row items-center w-full">
        <div className="relative flex  w-full m-auto pl-4">
          <Searchbar className="sm:w-7" />
          <div className="flex items-center ml-4 sm:ml-6">
            <p className="hidden sm:block ml-2">YupUp Admin</p>
          </div>
          <div>
            <Avatar className="ml-2 hidden sm:block" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
